































import { BAlert } from 'bootstrap-vue';

import { format, parse } from 'date-fns';
import { ajax } from 'jquery';
import { mapKeys, snakeCase, get } from 'lodash';
import Schedule from '../../recurrence/Schedule.vue';
import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';
import { DATE_FORMAT, DISPLAY_DATE_FORMAT, RecurrenceTypes, PeriodOptions } from '../../recurrence/utils';
import { createStringRule } from '../../recurrence/rules';
import { reload } from '@/utils';
import { ServerResponse } from './types';

export default {
  name: 'NewRecurrenceModal',
  components: {
    GenericCard,
    BAlert,
    Schedule,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
    },
    csrfToken: {
      type: String,
      required: true,
    },
    recApiUrl: {
      type: String,
      required: true,
    },
    scheduleData: {
      type: Array,
      default() {
        return [];
      },
    },
    objectTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saving: false,
      form: this.initForm(),
      errors: [],
    };
  },
  computed: {
    editing() {
      const rule = this.scheduleData.find(field => field.name.toLowerCase().includes('rule'));
      return rule;
    },
  },
  created() {
    this.$emit('updateConfig', { size: ModalSize.Small });
  },
  methods: {
    getRecurrencePayload() {
      const repeatOption = get(this.form, 'repeatOption.value', PeriodOptions.DoesNotRepeat);
      const payload = {
        rule: createStringRule(this.form),
        startOn: this.form.startDate,
        dueOn: this.form.endDate,
        recurrenceType: repeatOption === PeriodOptions.Custom ? RecurrenceTypes.Custom : RecurrenceTypes.Standard,
      };

      return payload;
    },
    save() {
      this.errors = [];
      const payload = this.getRecurrencePayload();
      const postData = mapKeys(payload, (v, k) => snakeCase(k));

      ajax({
        type: 'POST',
        url: this.recApiUrl,
        contentType: 'application/json',
        headers: { 'X-CSRF-Token': this.csrfToken },
        data: JSON.stringify({
          repeat_settings: postData,
        }),
        success: (response: ServerResponse) => {
          if (response.errors && response.errors.length > 0) {
            this.errors = response.errors;
          } else if (response.success) {
            const refreshAfter = GGRC.zenModal.modals.length < 2;
            this.$emit('close');
            if (refreshAfter) {
              this.reload();
            }
          }
        },
        error: () => {
          this.errors = ['Ups, something went wrong.'];
        },
      });
    },
    openConfirmStop() {
      window.GGRC.zenModal.show({
        type: 'NewStopRecurrenceModal',
        data: {
          type: this.type,
          csrfToken: this.csrfToken,
          recApiUrl: this.recApiUrl,
          objectTitle: this.objectTitle,
        },
        config: { ignoreUrl: true },
      });
    },
    initForm() {
      const today = new Date();
      const form = {
        startDate: null,
        endDate: null,
        repeatOption: null,
        stopRepeating: null,
        stopOn: null,
        repeatOn: null,
        repeatTimes: 1,
        repeatInterval: 1,
        period: null,
      };

      const startsOn = this.scheduleData.find(field => field.name.toLowerCase().includes('starts on'));
      form.startDate =
        startsOn.viewModel && startsOn.viewModel.value
          ? format(parse(startsOn.viewModel.value, DISPLAY_DATE_FORMAT, new Date()), DATE_FORMAT)
          : format(today, DATE_FORMAT);

      const endsOn = this.scheduleData.find(field => field.name.toLowerCase().includes('due on'));
      form.endDate =
        endsOn.viewModel && endsOn.viewModel.value
          ? format(parse(endsOn.viewModel.value, DISPLAY_DATE_FORMAT, new Date()), DATE_FORMAT)
          : null;
      return form;
    },
    reload,
  },
};
